import { tryParseJSON } from "@eventr/common";
import { ColoursObj } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { cardTranslation } from "i18n/translateHelpers";
import { CardText } from "../subComponents/cardText";
import { RowInfoFiles } from "../subComponents/rowInfoFiles";
import { RowInfoNotes } from "../subComponents/rowInfoNotes";
import { RowInfoStandart } from "../subComponents/RowInfoStandart";
interface HotelRoomInfoProps {
  roomType?: string;
  extra_docs?: string;
  notes?: string;
  bookingRef?: string;
}

export const HotelRoomInfo = ({ extra_docs, notes, bookingRef, roomType }: HotelRoomInfoProps) => {
  const files = useMemo(() => {
    if (!extra_docs) return [];
    return tryParseJSON(extra_docs, []) as string[];
  }, [extra_docs]);

  if (!files.length && !notes && !roomType && !bookingRef) return null;
  return (
    <Stack spacing="8px" sx={{
      paddingBottom: "8px"
    }}>
      <CardText variant="bodyBold">{cardTranslation("Guest Booking Information")}</CardText>
      {roomType && (
        <RowInfoStandart
          icon="Stays"
          bubbleColour={ColoursObj.coreBrights.tertiary}
          end={roomType}
          middle={cardTranslation("Room Type")}
        />
      )}
      {bookingRef && (
        <RowInfoStandart
          icon="Ticket"
          bubbleColour={ColoursObj.coreBrights.secondary}
          end={bookingRef}
          middle={cardTranslation("Booking Reference")}
        />
      )}
      {notes && <RowInfoNotes notes={notes} />}
      {files && <RowInfoFiles files={files} />}
    </Stack>
  );
};
